/**
 * 用户相关 API
 */
import { gapiRequest } from './request'
import type { User, LoginRequest, LoginResponse, CaptchaResponse, MfaSetupResponse } from '@/types/user'

export const userApi = {
  // 获取图形验证码
  getCaptcha: () =>
    gapiRequest.get<any, CaptchaResponse>('/v1/admin/captcha'),

  // 登录 (支持密码登录和验证码登录)
  login: (data: LoginRequest) =>
    gapiRequest.post<any, LoginResponse>('/v1/admin/login', data),

  // 两阶段验证：获取绑定信息（Admin 首次登录，扫码用）
  mfaSetup: (mfa_token: string) =>
    gapiRequest.post<any, MfaSetupResponse>('/v1/admin/mfa/setup', { mfa_token }),

  // 两阶段验证：确认绑定（提交首个动态码），成功后返回完整登录信息
  mfaConfirm: (mfa_token: string, code: string) =>
    gapiRequest.post<any, LoginResponse>('/v1/admin/mfa/setup/confirm', { mfa_token, code }),

  // 两阶段验证：校验动态码（已绑定用户），成功后返回完整登录信息
  mfaVerify: (mfa_token: string, code: string) =>
    gapiRequest.post<any, LoginResponse>('/v1/admin/mfa/verify', { mfa_token, code }),

  // 发送验证码
  sendCode: (phone_number: string, captcha_token: string, captcha_code: string) =>
    gapiRequest.post<any, { msg: string }>('/v1/admin/send_code', {
      phone_number,
      captcha_token,
      captcha_code,
      sys_group: 8,
    }),

  // 获取当前用户信息
  getCurrentUser: () =>
    gapiRequest.get<any, User>('/v1/admin/me'),
}
